import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/#work", label: "Our Work", testid: "nav-work-link" },
  { to: "/#contact", label: "Contact", testid: "nav-contact-link" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-zinc-800/80 bg-[#0C0F1C]/70 backdrop-blur-xl">
      <div className="flex items-center justify-between px-6 md:px-12 h-16 md:h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src="/assets/osc-logo.png" alt="OSC Collision Repairs" className="h-9 md:h-11 w-auto" />
          <span className="hidden sm:block text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            Okanagan Street Customs
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className="text-xs uppercase tracking-[0.25em] text-zinc-400 hover:text-zinc-100 transition-colors duration-300"
            >
              {l.label}
            </Link>
          ))}
          <Link to="/book" data-testid="nav-book-button" className="osc-btn-primary !py-3 !px-6">
            Book Appointment
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="md:hidden text-zinc-100 p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="md:hidden overflow-hidden border-t border-zinc-800 bg-[#0C0F1C]/95 backdrop-blur-xl"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`mobile-${l.testid}`}
                  onClick={() => setOpen(false)}
                  className="text-sm uppercase tracking-[0.25em] text-zinc-300"
                >
                  {l.label}
                </Link>
              ))}
              <Link
                to="/book"
                data-testid="mobile-nav-book-button"
                onClick={() => setOpen(false)}
                className="osc-btn-primary justify-center"
              >
                Book Appointment
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
